/**
 * PBR材质渲染质量。
 */
export enum PBRRenderQuality {
    /**高质量。*/
    High,
    /**低质量。*/
    Low
}